import { Injectable } from "@angular/core";
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

export type SaveInspectListResponce = {
  FileName: string,
}

/**
 * プロモ商品企画点検リスト出力クラス
 *
 * @export SaveInspectListService
 * @class SaveInspectListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SaveInspectListService extends PlessJsonResponderSub<SaveInspectListResponce> {

  // 処理に使用するModel
  private vo: any;
  private successFunc: Function = () => { };

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエスト
   * @memberof SaveInspectListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
        MediumType: this.vo.mediumType,
        PCode: this.vo.pCode,
        ItemCode: this.vo.itemCode,
        OrderNum: this.vo.orderNum,
        BundleCatalogRoundId: this.vo.bundleCatalogRoundId,
        OutputFlag: this.vo.outputFlag,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof SaveInspectListService
   */
  execute(vo: any, successFunc: Function): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('saveInspectList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveInspectListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
